import { IFileNameParts } from "../interfaces/IFormatUtils";

export function bytesTo(bytes: number): string {
  const kb = bytes / 1024;
  const mb = kb / 1024;

  if (mb >= 1) return `${mb.toFixed(2)} MB`;
  return `${kb.toFixed(2)} KB`;
}

export function truncate(text: string | undefined, max = 30): string {
  if (!text) return '-';
  const t = text.trim();
  if (t.length <= max) return t;
  return t.slice(0, Math.max(0, max - 1)).trimEnd() + '…';
}

export function splitFileName(fileName?: string | null): IFileNameParts {
  if (!fileName) return { name: '-', ext: '' };

  const trimmed = fileName.trim();
  const lastDot = trimmed.lastIndexOf('.');

  return {
    name: trimmed.slice(0, lastDot),
    ext: trimmed.slice(lastDot), // incluye el punto
  };
}

export function initials(name?: string | null): string {
  if (!name) return '';

  const parts = name
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (parts.length === 0) return '';

  const first = parts[0].charAt(0);
  const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : '';

  return (first + last).toUpperCase();
}
